import { Box, Text } from 'braid-design-system';

import { VerifiedIdTickTooltip } from '../../VerifiedIdTickTooltip/VerifiedIdTickTooltip';

interface NameProps {
  hasEthicalHiring: boolean;
  displayName: string;
  digitalIdentity: {
    isVerified: boolean;
    verifiedName?: string | null;
  };
  isSignedIn: boolean;
}

export const Name = ({
  hasEthicalHiring,
  displayName,
  digitalIdentity,
  isSignedIn,
}: NameProps) => (
  <Box display="flex" gap="xxsmall" alignItems="center">
    <Text weight="strong" maxLines={1} size="large" data={{ role: 'heading' }}>
      {displayName}
    </Text>
    {digitalIdentity.isVerified ? (
      <Text>
        <VerifiedIdTickTooltip
          hasEthicalHiring={hasEthicalHiring}
          isSignedIn={isSignedIn}
          verifiedName={digitalIdentity.verifiedName}
          profileName={displayName}
        />
      </Text>
    ) : null}
  </Box>
);
